export const CUSTOMER_STATE_KEY = 'customers';
export const DIVISION_STATE_KEY = 'divisions';
export const DIVISION_PHONE_NUMBER_KEY = 'division-phone-numbers';
